import { Button } from '@clockout-dev/design-elements';
import { ArrowLeftOutlined } from '@ant-design/icons';
import styles from '../styles/page.module.scss';

function GoBackButton({ label, onClick }) {
    return (
        <Button
            type="button"
            variant="link"
            color="secondary"
            size="m"
            className={styles.backLink}
            onClick={onClick}
        >
            <ArrowLeftOutlined />
            {label}
        </Button>
    )
}
export default GoBackButton;